import { type ReactNode } from 'react';

import type { Research } from '@/lib/crm/record/research/useResearch';

import type { MeetingPrepPerson } from '../utils/meetingPrepTypes';
import { MeetingPrepAccordionSection } from './meeting-prep-accordion-section';
import { MeetingPrepPersonCard } from './meeting-prep-person-card';

interface MeetingPrepPeopleSectionProps {
  people: MeetingPrepPerson[];
  rsvpMap: Map<string, string>;
  defaultExpanded: boolean;
  metadata?: string;
  badges?: ReactNode;
  researchById: Map<string, Research>;
}

export function MeetingPrepPeopleSection({
  people,
  rsvpMap,
  defaultExpanded,
  metadata,
  badges,
  researchById,
}: MeetingPrepPeopleSectionProps) {
  return (
    <MeetingPrepAccordionSection
      title='Contact research'
      sectionId='people'
      defaultExpanded={defaultExpanded}
      metadata={metadata}
      badges={badges}
    >
      {people.map(person => (
        <MeetingPrepPersonCard
          key={person.entity_id ?? person.email}
          person={person}
          rsvpStatus={rsvpMap.get(person.email?.toLowerCase())}
          research={researchById.get(person.research_entity_id ?? '')}
        />
      ))}
    </MeetingPrepAccordionSection>
  );
}
